import { z } from "zod";

/** Optional free text from a form: trims, and treats a blank value as absent. */
export const optionalText = (max: number) =>
  z
    .string()
    .trim()
    .max(max)
    .optional()
    .transform((v) => (v === "" ? undefined : v));

export const idSchema = z.number().int().positive();

/** The opaque token from an emailed or shared link. */
export const accountTokenSchema = z.string().min(20).max(200);
